var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-shell course-detail-page"},[_c('MobileTopNav',{attrs:{"title":"课程详情"}}),_c('main',{staticClass:"course-detail-main"},[_c('img',{staticClass:"course-detail-image",attrs:{"src":_vm.courseImage,"alt":`${_vm.courseName}课程详情`}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }